module.exports = __webpack_public_path__ + "img/75643.a7856c75.svg";